// This file is managed by `scripts/sync-addresses.mjs`. Run `bun sync-addresses`
// after each local deploy to refresh it from ../blockpot-contracts' `addresses.json`,
// or pipe a Railway-style CHAINS_CONFIG JSON via `--chains-config-json` for hosted chains.
//
// Mainnet (chainId 1) is a placeholder until the operator stack is deployed there;
// the console reads these as `undefined` and surfaces the chain as unconfigured.
const MAINNET_ADDRESSES: { [key: string]: `0x${string}` } = {}

export default MAINNET_ADDRESSES
